import { render, staticRenderFns } from "./OnboardingOperatorTypeAlert.vue?vue&type=template&id=9bb64b16&lang=pug"
import script from "./OnboardingOperatorTypeAlert.vue?vue&type=script&lang=ts"
export * from "./OnboardingOperatorTypeAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCard})
